var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AdminUsersPageAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { AdminUsersDTO } from "../constanst/adminUsersDTO";
import React from "react";
export var UsersAdminView = function (props) {
    var _a, _b, _c, _d;
    return (_jsx(AdminUsersPageAFY, __assign({}, AdminUsersDTO, { drawerProps: __assign(__assign({}, AdminUsersDTO.drawerProps), { openDrawer: props.openDrawer, titleButton: props.rolesRows.length > 0 ? "Editar Roles" : "Agregar Roles" }), paginationProps: __assign(__assign({}, AdminUsersDTO.paginationProps), { count: (_a = props.countData) !== null && _a !== void 0 ? _a : 0, rowsPerPages: props.limit, pagePagination: props.page }), tableProps: __assign(__assign({}, AdminUsersDTO.tableProps), { rows: (_b = props.rolesRows) !== null && _b !== void 0 ? _b : [] }), viewGridProps: __assign(__assign({}, AdminUsersDTO.viewGridProps(props.onOptionsCardClick)), { rows: (_c = props.usersData) !== null && _c !== void 0 ? _c : [] }), permissions: {
            create: true,
            delete: true,
            update: true,
        }, userData: (_d = props.usersData) !== null && _d !== void 0 ? _d : [], onClickContextMenu: props.onOptionsCardClick, onChangePage: props.onChangePage, onChangeRowsPerPage: props.onChangeLimit, onClickButtonEditRoles: function () {
            props.setOpenDrawer(false);
            props.setOpenModalEditRoles(true);
        }, onCloseDrawer: function () { return props.setOpenDrawer(false); }, onChangeFilter: function (e) {
            props.setFiltersApplied(e);
        }, onClickAdd: function () {
            props.handleResetFormToInitialState();
            props.setIsEdit(false);
            props.setOpenModalAddNewUser(true);
        }, onChangeFullTextSearch: function (e) { return props.setSearchQuery(e); }, onBlurFullTextSearch: function () { }, onClickClearFilters: function () { } })));
};
